
import { Link } from 'react-router-dom';
import { services } from '../../../mocks/services';

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-rose-400 text-sm font-semibold tracking-wider uppercase">Unsere Leistungen</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Professionelle Behandlungen
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Entdecken Sie unser vielfältiges Angebot an hochwertigen Kosmetikbehandlungen für Ihr Wohlbefinden
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              to={`/preise/${service.slug}`}
              key={index}
              className="group bg-gradient-to-br from-white to-rose-50/30 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-rose-100/50 cursor-pointer block"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-rose-400 to-rose-300 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <span className="bg-rose-100 text-rose-600 px-3 py-1 rounded-full text-sm font-semibold">
                  {service.startingPrice}
                </span>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {service.description}
              </p>

              <div className="flex items-center text-rose-500 font-medium text-sm group-hover:text-rose-600 transition-colors">
                <span className="whitespace-nowrap">Mehr erfahren & Preise</span>
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
